var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOverdue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 21.6733L20.2929 14.3491C19.8981 13.6904 19.1757 13.2812 18.4082 13.2812C17.6407 13.2812 16.9183 13.6904 16.5235 14.3491L12.1297 21.6719C11.9244 22.0124 11.8164 22.4029 11.8164 22.8027C11.8164 24.0144 12.8021 25 14.0137 25H22.8027C24.0144 25 25 24.0144 25 22.8027C25 22.4029 24.892 22.0124 24.6875 21.6733ZM19.1406 22.8027H17.6758V21.3379H19.1406V22.8027ZM19.1406 19.873H17.6758V16.9434H19.1406V19.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4082 11.8164C18.6469 11.8164 18.8779 11.863 19.1082 11.9087C18.9275 9.21323 17.6177 6.82671 15.6546 5.20586L16.9405 3.36924L15.7403 2.52954L14.4561 4.36382C13.2358 3.63818 11.8434 3.17739 10.3516 3.06294V1.46484H11.8164V0C11.3524 0 7.87798 0 7.42188 0V1.46484H8.88672V3.06445C7.39551 3.17881 6.00254 3.63789 4.78135 4.36255L3.498 2.52954L2.2978 3.36924L3.57705 5.19634C1.45405 6.94409 0 9.59087 0 12.5488C0 17.7988 4.36914 22.0703 9.61914 22.0703C9.90195 22.0703 10.1803 22.0521 10.4569 22.0278C10.5416 21.638 10.6679 21.2594 10.8751 20.9159L15.2675 13.5952C15.9249 12.498 17.1286 11.8164 18.4082 11.8164ZM14.7461 13.2812H8.88457L8.88672 7.42188H10.3516L10.3494 11.8164H14.7461V13.2812Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOverdue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/overdue.3aece4be.svg";
export { ForwardRef as ReactComponent };